(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["munds-birthday-personalization"] && !Shopify.designMode) return;
  try {
    function mundsValidatePersonalization(event) {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const form = target.closest('form');
  if (!form) return;
  const fields = form.querySelector('[data-munds-personalization]');
  if (!fields) return;
  if (event.type === 'click' && !target.closest('[type="submit"]')) return;
  const invalid = Array.from(fields.querySelectorAll('input')).find((input) => !input.validity.valid);
  if (!invalid) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  invalid.reportValidity();
}
window.addEventListener('click', mundsValidatePersonalization, true);
window.addEventListener('submit', mundsValidatePersonalization, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["munds-occasion-personalization"] && !Shopify.designMode) return;
  try {
    function mundsValidateOccasionFields(event){
 const target=event.target;
 if(!(target instanceof Element))return;
 const form=target.closest('form');
 if(!form)return;
 const fields=form.querySelector('[data-munds-occasion-personalization]');
 if(!fields)return;
 if(event.type==='click'&&!target.closest('[type="submit"]'))return;
 const invalid=Array.from(fields.querySelectorAll('input,select')).find(input=>!input.validity.valid);
 if(!invalid)return;
 event.preventDefault();event.stopImmediatePropagation();invalid.reportValidity();
}
function mundsSyncCustomOccasions(){
 document.querySelectorAll('[data-munds-occasion-personalization]').forEach(fields=>{
  const select=fields.querySelector('[data-munds-occasion-select]');
  const wrapper=fields.querySelector('[data-munds-custom-occasion]');
  const input=fields.querySelector('[data-munds-custom-occasion-input]');
  if(!select||!wrapper||!input)return;
  const custom=select.value==='Anderer Anlass';
  wrapper.hidden=!custom;
  input.disabled=!custom;
  input.required=custom;
 });
}
document.addEventListener('change',event=>{
 if(!(event.target instanceof Element)||!event.target.matches('[data-munds-occasion-select]'))return;
 mundsSyncCustomOccasions();
});
mundsSyncCustomOccasions();
function mundsSuppressOldOccasionFields(){
 mundsSyncCustomOccasions();
 document.querySelectorAll('[data-munds-occasion-personalization]').forEach(fields=>{
  const scope=fields.closest('.product__info-container');
  if(!scope)return;
  scope.querySelectorAll('.textbox_fields input,.textbox_fields textarea,.textbox_fields select').forEach(input=>{input.disabled=true;input.required=false;});
 });
}
mundsSuppressOldOccasionFields();
const mundsOccasionObserver=new MutationObserver(mundsSuppressOldOccasionFields);
mundsOccasionObserver.observe(document.body,{childList:true,subtree:true});
window.addEventListener('click',mundsValidateOccasionFields,true);
window.addEventListener('submit',mundsValidateOccasionFields,true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["munds-school-personalization"] && !Shopify.designMode) return;
  try {
    function mundsValidateSchoolFields(event) {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const form = target.closest('form');
  if (!form) return;
  const fields = form.querySelector('[data-munds-school-personalization]');
  if (!fields) return;
  if (event.type === 'click' && !target.closest('[type="submit"]')) return;
  const invalid = Array.from(fields.querySelectorAll('input, select')).find((input) => !input.validity.valid);
  if (!invalid) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  invalid.reportValidity();
}
window.addEventListener('click', mundsValidateSchoolFields, true);
window.addEventListener('submit', mundsValidateSchoolFields, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["munds-wedding-personalization"] && !Shopify.designMode) return;
  try {
    function mundsValidateWeddingFields(event) {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const form = target.closest('form');
  if (!form) return;
  const fields = form.querySelector('[data-munds-wedding-personalization]');
  if (!fields) return;
  if (event.type === 'click' && !target.closest('[type="submit"]')) return;
  const invalid = Array.from(fields.querySelectorAll('input')).find((input) => !input.validity.valid);
  if (!invalid) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  invalid.reportValidity();
}
window.addEventListener('click', mundsValidateWeddingFields, true);
window.addEventListener('submit', mundsValidateWeddingFields, true);
  } catch(e) { console.error(e); }
})();

})();
